import React from 'react'
import { Box, Typography } from '@mui/material'

export const ImageTest: React.FC = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Test de Imagen
      </Typography>
      
      {/* Test directo de la imagen */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Imagen directa:
        </Typography>
        <img 
          src="/images/escondida-open-pit.jpg" 
          alt="Open Pit Test"
          style={{ 
            width: '100%', 
            maxWidth: '600px', 
            height: 'auto',
            border: '2px solid red' // Para ver si carga
          }}
          onLoad={() => console.log('✅ Imagen cargada correctamente')}
          onError={() => console.log('❌ Error al cargar imagen')}
        />
      </Box>

      {/* Test con background-image */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Background image:
        </Typography>
        <Box
          sx={{
            width: '100%',
            maxWidth: '600px',
            height: '300px',
            backgroundImage: 'url(/images/escondida-open-pit.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            border: '2px solid blue',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
          }}
        >
          <Typography variant="h5">
            Texto sobre imagen
          </Typography>
        </Box>
      </Box>

      {/* Lista de imágenes disponibles */}
      <Box>
        <Typography variant="h6" gutterBottom>
          Imágenes disponibles:
        </Typography>
        <ul>
          <li>/images/escondida-open-pit.jpg</li>
          <li>/images/escondida-open-pit2.jpg</li>
          <li>/images/original.jpg</li>
        </ul>
      </Box>
    </Box>
  )
}